import { render } from "./BarresRouges.vue?vue&type=template&id=4a5e044f&scoped=true"
import script from "./BarresRouges.vue?vue&type=script&lang=js"
export * from "./BarresRouges.vue?vue&type=script&lang=js"

import "./BarresRouges.vue?vue&type=style&index=0&id=4a5e044f&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5e044f"]])

export default __exports__